'use strict';

angular.module('imagetrend.components')
    .controller('PostalCodeModalController', ['$scope', '$uibModalInstance', 'postalCode', 'addresses', 'FIPSLookup', function ($scope, $uibModalInstance, postalCode, addresses, FIPSLookup) {
        $scope.postalCode = postalCode;
        $scope.addresses = addresses;

        $scope.select = function (address) {
            $uibModalInstance.close(address);
        }

        $scope.no = function () {
            $uibModalInstance.close(null);
        }

        $scope.lookupZip = function () {
            $scope.postalSearching = true;
            $scope.postalCode = $scope.postalCode || "";
            FIPSLookup.getByPostalCode($scope.postalCode).then(function (data) {
                if (data != null) {
                    $scope.addresses = data;
                } else {
                    $scope.failMessage = "Could not find information for this postal code.";
                }
                $scope.postalSearching = false;
            });
        }

        $scope.onChange = function (item) {
            if ($scope.postalCode.length == 5) {
                $scope.lookupZip();
            }
        }
    }])
;